import { AppModule } from '@/store/modules/app'
import { PermissionModule } from '@/store/modules/permission'

export const checkPermission = (value: string): boolean => {
  return PermissionModule.permission.includes(value)
}


export const checkNeedAudit = (authCode: string): string => {
  return PermissionModule.approval_task_detail[authCode]?.title
}


export const isShowDialog = (authCode: string): boolean => {
  return checkNeedAudit(authCode) !== undefined || AppModule.enterprise.google_auth_switch
}